import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Microcentrifuge extends React.Component {
  componentWillMount() {
    this.props.createMicrocentrifuge({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"Microcentrifuge_"+this.props.id}
          className={'Microcentrifuge dropTarget'}>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Microcentrifuge.propTypes = {
  createMicrocentrifuge: PropTypes.func,
};

Microcentrifuge.defaultProps = {};
